import React, { useState } from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import TreatmentText from '../../TreatmentText'
import MaskType from './MaskType'
import FlowRate from './FlowRate'
import TreatmentOutcome from '../../TreatmentOutcome'
import TreatmentSubmitModule from '../../TreatmentSubmitButton'

const Oxygen = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Oxygen Therapy</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <MaskType
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <FlowRate
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentOutcome
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          lg={4}
        />
        <TreatmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentSubmitModule
          moduleName="Oxygen"
          moduleValues={moduleValues}
          submitModule={submitModule}
        />
      </Grid>
    </Box>
  )
}

export default Oxygen
